import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "col-12 p-inputgroup" }
const _hoisted_5 = { class: "p-inputgroup-addon" }
const _hoisted_6 = { class: "col-12 p-inputgroup" }
const _hoisted_7 = { class: "p-inputgroup-addon" }
const _hoisted_8 = { class: "grid p-fluid" }
const _hoisted_9 = { class: "col-10 md:col-12" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "grid"
}
const _hoisted_12 = { class: "col-6 p-inputgroup" }
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "flex -my-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Prompt = _resolveComponent("Prompt")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.researchGroup.form.basicData")), 1),
    ($setup.state.researchGroupDto)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString($setup.t("content.dataManagement.content.researchGroup.form.number")), 1),
                _createVNode(_component_InputText, {
                  modelValue: $setup.state.researchGroupDto.number,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.researchGroupDto.number) = $event)),
                  placeholder: 
                $setup.t('content.dataManagement.content.researchGroup.form.number')
              
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString($setup.t("content.dataManagement.content.researchGroup.form.name")), 1),
                _createVNode(_component_InputText, {
                  modelValue: $setup.state.researchGroupDto.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.researchGroupDto.name) = $event)),
                  placeholder: 
                $setup.t('content.dataManagement.content.researchGroup.form.name')
              
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Button, {
          label: $setup.t('content.globalSaveButton'),
          class: "minWidth",
          onClick: $setup.onResearchGroupCreateClick
        }, null, 8, ["label", "onClick"])
      ])
    ]),
    ($setup.isEditModeEnabled)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_10, _toDisplayString($setup.t("content.dataManagement.content.researchGroup.form.users")), 1))
      : _createCommentVNode("", true),
    ($setup.isEditModeEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_Dropdown, {
                modelValue: $setup.state.userId,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.userId) = $event)),
                options: $setup.state.usersFiltered,
                "option-label": "fullname",
                "option-value": "id",
                filter: true,
                class: "w-full",
                "show-clear": true,
                onFilter: _cache[3] || (_cache[3] = ($event: any) => ($setup.onUserFilterChange($event))),
                onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.onUserChange($event)))
              }, null, 8, ["modelValue", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Button, {
              label: $setup.t('content.globalAddNewButton'),
              class: "minWidth p-button",
              onClick: $setup.onUserAddClick
            }, null, 8, ["label", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_DataTable, {
              class: "p-datatable-sm",
              "column-resize-mode": "fit",
              "resizable-columns": true,
              "responsive-layout": "scroll",
              lazy: true,
              "total-records": $setup.state.lazyParams.total,
              "selection-mode": "single",
              value: $setup.state.users,
              "filter-display": "menu",
              paginator: true,
              rows: $setup.state.lazyParams.rows,
              "rows-per-page-options": [5, 10, 40],
              "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
              "current-page-report-template": `{currentPage} ${$setup.t(
            'content.globalPagingInformation.ofTitle'
          )} {totalPages} ${$setup.t('content.globalPagingInformation.pagesTitle')}`,
              "data-key": "id",
              loading: $setup.state.dataLoading,
              onPage: _cache[5] || (_cache[5] = ($event: any) => ($setup.onPaginatorUsersClick($event)))
            }, {
              paginatorend: _withCtx(() => []),
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.t("content.noData")), 1)
              ]),
              loading: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.t("content.globalLoadingText")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "firstname",
                  header: 
              $setup.t(
                'content.dataManagement.content.researchGroup.table.header.firstname'
              )
            
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.data.firstname), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "lastname",
                  header: 
              $setup.t(
                'content.dataManagement.content.researchGroup.table.header.lastname'
              )
            
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.data.lastname), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "id",
                  header: "",
                  "header-style": "text-align:center; width: 20px;"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_Button, {
                        icon: "pi pi-times",
                        class: "p-button-outlined p-button-danger ml-2",
                        onClick: ($event: any) => ($setup.onRemoveUserClickOpenDialog(data.id))
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["total-records", "value", "rows", "current-page-report-template", "loading"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Prompt, {
      visible: $setup.state.promptRemoveUser,
      type: "alert",
      title: $setup.t('content.globalDeleteButton'),
      onClose: _cache[8] || (_cache[8] = ($event: any) => ($setup.state.promptRemoveUser = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("h3", null, _toDisplayString($setup.t("content.globalAreYouSure")), 1)
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-outlined",
          label: $setup.t('content.globalCancelButton'),
          onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.state.promptRemoveUser = false))
        }, null, 8, ["label"]),
        _createVNode(_component_Button, {
          label: $setup.t('content.globalDeleteButton'),
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.onRemoveUserClick()))
        }, null, 8, ["label"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}